import {ODATA_COLUMN_TYPES} from "../../utils/odata";

export const DIMENSION_TYPE = {
  territorial: ODATA_COLUMN_TYPES.territorial,
  dimension: ODATA_COLUMN_TYPES.dimension,
  image: ODATA_COLUMN_TYPES.image,
  addr: ODATA_COLUMN_TYPES.addr,
  lat: ODATA_COLUMN_TYPES.lat,
  lon: ODATA_COLUMN_TYPES.lon,
  website: ODATA_COLUMN_TYPES.website,
  phone: ODATA_COLUMN_TYPES.phone,
  note: ODATA_COLUMN_TYPES.note,
  mail: ODATA_COLUMN_TYPES.mail,
  coordinates: ODATA_COLUMN_TYPES.coordinates,
  dateTime: ODATA_COLUMN_TYPES.dateTime,
  time: ODATA_COLUMN_TYPES.time,
  day: ODATA_COLUMN_TYPES.day,
  month: ODATA_COLUMN_TYPES.month,
  year: ODATA_COLUMN_TYPES.year,
  quarter: ODATA_COLUMN_TYPES.quarter,
  quadrimester: ODATA_COLUMN_TYPES.quadrimester,
  semester: ODATA_COLUMN_TYPES.semester,
  identifier: ODATA_COLUMN_TYPES.identifier
};

export const FILTER_DIM_SEPARATOR = "+";
